





























import { Vue, Component } from 'vue-property-decorator';
import CommonTable, { TableColumn } from '../../components/organisms/CommonTable.vue';
import { TeacherService } from '../../biz/remote/TeacherService';
import { TeacherInfoInputDTO } from '../../../src_server/entity/dto/TeacherInfoInputDTO';
import TeacherInfoMaintenance from './TeacherInfoMaintenance.vue';
import { dayjs, DT_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { ActorType, ActorTypeNames } from '../../../src_server/biz/ActorType';
@Component({
  components: { TeacherInfoMaintenance, CommonTable },
})
export default class TeacherFailuerListPage extends Vue {
  private loading = false;
  public teacherCols: TableColumn[] = [
    { label: 'no', type: 'seq' },
    {
      label: '詳細',
      btnClass: { btn: true, 'btn-primary btn-sm': true },
      onclick: this.detail,
    },

    {
      label: '',
      type: 'renderfunc',
      representedAs: (row: TeacherInfoInputDTO) => {
        return `<a href="${row.teacher.img_path}" target="_blank" ><img class="rounded-circle shadow"  height="60px" src="${row.teacher.img_path}" /></a>`;
      },
    },

    {
      label: '氏名',
      type: 'renderfunc',
      representedAs: (row: any) => {
        const actor = ActorType.getInstanceByName(row.communicate.actor_type as ActorTypeNames);

        return `<div>${row.teacher.full_name}</div>
          <div>${row.teacher.gender}</div>
          <div>${actor?.typeName}</div>
        `;
      },
      width: '100px',
    },
    {
      label: '申込日',
      type: 'renderfunc',
      representedAs: (row: any) => {
        return `<div class="fz-xsm">${dayjs(row.teacher.application_dt).format('YYYY年MM月DD日')}</div>
        <div class="fz-xsm">${dayjs(row.teacher.application_dt).format('HH:mm')}</div>`;
      },
      width: '125px',
    },
    { label: '資格', name: 'teacher.qualification', width: '125px' },
    {
      label: '所属',
      type: 'renderfunc',
      representedAs: (row: TeacherInfoInputDTO) => {
        return `<div>${row.teacher.work_place}</div>
        <br>
        <div>${row.teacher.school_name}</div>`;
      },
    },
    { label: '最終学歴', name: 'teacher.final_education' },
    { label: '退会予定', name: 'teacher.time_to_quit' },
    { label: '都道府県', name: 'teacher.prefecture' },
  ];

  detail(row: any) {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.show(row);
  }

  cancel() {
    const dialog = this.$refs['teacher_detail_dialog'] as TeacherInfoMaintenance;
    dialog.hide();
  }

  private biz = new TeacherService();

  private teacherRows: TeacherInfoInputDTO[] = [];

  private selectedTeacher = {};

  loadData() {
    this.loading = true;
    this.biz.getFailureTeacherInfo().then((res) => {
      this.teacherRows = res.data;
      this.loading = false;
    });
  }

  get model() {
    return this.teacherRows;
  }

  mounted() {
    this.loadData();
  }
}
